import { Toolbar, Button, Box, Stack } from "@mui/material";
import { ErrorBoundary, LargeScreenDialog, ShowWarningConfirmation, SibaGridColumn, SibaLinearLoadingIndicator, SmallScreenDialog } from "@siba/components";
import { growlInfo, userManagementUtil } from "@siba/utilities";
import { formatNumberCurrency, gridDateFormat, useGenericFormMethods } from "Application/Pages/formMethods/genericMethods";
import { useSaveExternalBidMutation, useUpdateExternalBidMutation,useRemoveExternalBidMutation, useGetAllExternalBidMutation } from "Application/features/services/apis/Home/ExternalBidApiService";
import React, { useEffect, useState } from "react";
import { ExternalBid } from "./../../../features/models/Home/ExternalBid";
import ModalForm from "./BidUpdateForm";
import SalvageDetailModalForm from "./SalvageDetails";
import { SearchGrid } from "Application/Components/SearchGrid/SearchGrid";
import { useGetBidderBidsByIdMutation } from "Application/features/services/apis/Home/BidderRegisterApiService";
import isEmpty from "Application/Components/Validations/IsEmpty";
import { queryResponse } from "Application/features/services/backends/sibaApis";
const BidList: React.FC = () => {
    /**
     * Save  hook generated by @see ExternalBidServiceApi
     * points to the save enpoint.
     */
    const [save] = useSaveExternalBidMutation();

    /**
     * Update  hook generated by @see ExternalBidServiceApi
     * points to the Update enpoint.
     */
    const [update] = useUpdateExternalBidMutation();
    const [deleteBidData] = useRemoveExternalBidMutation();
    /***
     * Remove  hook generated by @see ExternalBidServiceApi
     * points to the Fetch enpoint.
     */
    const [getAll] = useGetAllExternalBidMutation();
    const [getById] = useGetBidderBidsByIdMutation();
    /**
     * genericMethods is generic method, property  generator tha returns
     * default/ generic event handlers for a setup form.
     * @prop Name is defaulted as the name of the setup and shown on the form.
     * @prop saveMethod - a save endpoint/ function for the setup.
     * @prop removeMethod - points to the remove method, endpoint for the setup.
     * @prop updateMethod - points to the update method / endpont for the setup.
     * @returns generic methods / properties for setup form.
     * @type IAddressType
     * **/
    const genericMethods = useGenericFormMethods<ExternalBid>({
        formName: "External Bid",
        saveMethod: save,
        updateMethod: update,
        getAllMethod: getAll,
        getByIdMethod: getById
    });
    const isConfirmedTemplate = (props: any): any => {
        if (props.BidConfirmed === true) {
            return (
                <span className={"badge bg-success"} style={{ fontSize: "12px" }}>
                    Yes
                </span>
            );
        } else {
            return (
                <span className={"badge bg-danger"} style={{ fontSize: "12px" }}>
                    No
                </span>
            );
        }
    };
    const isApprovedTemplate = (props: any): any => {
        if (props.BidConfirmed === true) {
            return (
                <span className={"badge bg-success"} style={{ fontSize: "12px" }}>
                    Yes
                </span>
            );
        } else {
            return (
                <span className={"badge bg-danger"} style={{ fontSize: "12px" }}>
                    No
                </span>
            );
        }
    };
    const bidAmountFormatTemplate = (props: any): any => {
        if (props.BidAmount) {
            return <label>{formatNumberCurrency(props.BidAmount)}</label>;
        } else {
            return <label>0.00</label>;
        }
    };
    const gridCollumnDefinition: SibaGridColumn[] = [
        { field: "Id", headerText: "Bid ID", width: 150 },
        { field: "CreatedDate", headerText: "Bid Date", width: 150, template: gridDateFormat("CreatedDate") },
        { field: "Make", headerText: "Make", width: 150 },
        { field: "Model", headerText: "Model", width: 150 },
        { field: "VehicleNumber", headerText: "Registration Number", width: 150 },
        { field: "BidderCode", headerText: "BidderCode", width: 150 },
        { field: "Currency", headerText: "Bid Currency", width: 150 },
        { field: "BidAmount", headerText: "Amount Proposed", width: 150, template: bidAmountFormatTemplate },
        {
            field: "PhoneNumber",
            headerText: "Phone Number",
            width: 150
        },
        { field: "BidderCode", headerText: "BidderCode", width: 150 },
        { field: "Email", headerText: "Email", width: 150 },

        { field: "Address", headerText: "Address", width: 150 },

        { field: "BidConfirmed", headerText: "Confirmed?", width: 150, template: isConfirmedTemplate },
        { field: "BidApproved", headerText: "Approved?", width: 150, template: isApprovedTemplate }
    ];
    const [openVehicleDetail, setOpenVehicleDetail] = useState(false);
    const openModal = () => {
        if (isEmpty(genericMethods.model)) {
            growlInfo(`Select a bid first in order to view it's associated vehicle details!`);
        } else {
            setOpenVehicleDetail(true);
        }
    };
    const deleteBid = () => {
        if (!isEmpty(genericMethods.model)) {
            ShowWarningConfirmation("Are you sure you want to delete the selected bid?", async () => {
                const bid = genericMethods.model;
                bid.Status = "3";
                const response: queryResponse<any> | any = await deleteBidData(bid);
                if(response){
                    genericMethods.setModelCollection([...genericMethods.modelCollection.filter((x) => x.Id !== genericMethods.model.Id)]);
                }
               
            });
        } else {
            growlInfo("Select a bid first to proceed with deleting it!");
        }
    };
    useEffect(() => {
        try {
            genericMethods.handleModelGetById(userManagementUtil.getUserId());
        } catch (e) {
            growlInfo("Login to your account to view all your active bids");
        }
    }, []);

    return (
        <>
            <SibaLinearLoadingIndicator />
            <Box component="main" sx={{ p: 3 }}>
                <Toolbar />
                <div className="container">
                    <ErrorBoundary>
                        <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 1, sm: 2, md: 4 }} style={{ marginTop: "15px" }}>
                            <Button variant="contained" color="primary" component="label" onClick={openModal}>
                                {" "}
                                View Bid Vehicle Detail
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                component="label"
                                onClick={() => {
                                    genericMethods.formHandler.reset({
                                        SalvageId: genericMethods.model.SalvageId,
                                        BidderCode: genericMethods.model.BidderCode,
                                        BidderName: genericMethods.model.BidderName,
                                        Address: genericMethods.model.Address,
                                        Email: genericMethods.model.Email,
                                        Currency: genericMethods.model.Currency,
                                        Status: "2"
                                    });
                                    genericMethods.handleClickView();
                                }}
                            >
                                {" "}
                                Update Bid
                            </Button>
                            <Button variant="contained" color="error" component="label" onClick={deleteBid}>
                                {" "}
                                Delete Bid
                            </Button>
                        </Stack>
                        <SearchGrid
                            data={genericMethods.modelCollection}
                            handleSelect={genericMethods.setModel}
                            handleDoubleClick={genericMethods.gridDoubleClickModalResponse}
                            columnDefinition={gridCollumnDefinition}
                        />
                    </ErrorBoundary>
                </div>
            </Box>
            <SmallScreenDialog
                title={genericMethods.modalTitle}
                onClose={genericMethods.handleClickClose}
                visible={genericMethods.modalOpen}
                onSave={genericMethods.handleSave(genericMethods.saveType)}
            >
                <ModalForm formHandler={genericMethods.formHandler} bid={genericMethods.model} />
            </SmallScreenDialog>
            <LargeScreenDialog
                title={"Bid Vehicle Details"}
                onClose={() => {
                    setOpenVehicleDetail(false);
                }}
                visible={openVehicleDetail}
            >
                <SalvageDetailModalForm salvageId={genericMethods.model.SalvageId!} />
            </LargeScreenDialog>
        </>
    );
};

export default BidList;
